const slug = 'media-player-addons-for-elementor';
import { VimeoIcon, youTubeIcon, modernAudioPlaylistIcon, classicAudioPlaylistIcon, cardAudioPlaylistIcon, dPlayerIcon, advanceAudioPlaylistIcon, advanceVideoPlayerIcon, artPlayerIcon, html5AudioIcon, html5videoIcon, advanceAudioPlayerIcon, audioPlaylistIcon, videoPlaylistIcon, classicVideoPlaylistIcon } from './blocksIcon';

export const dashboardInfo = (info) => {
	const { version, isPremium, hasPro, adminUrl = '', pricingUrl, nonce, action, licenseActiveNonce } = info;

	const proSuffix = isPremium ? ' Pro' : '';

	return {
		name: `Media Player Addons for Elementor${proSuffix}`,
		displayName: `Media Player Addons for Elementor${proSuffix} - Audio and Video Widgets for Elementor.`,
		description: 'Media Player Addons for Elementor is a comprehensive WordPress plugin that adds 15 advanced media player widgets to the Elementor page builder. It enables you to embed and customize audio and video content — including support for popular formats (.mp3, .mp4, .flv, .ogg, .webm), live streaming (HLS, DASH), playlists, picture-in-picture video, captions, and more — without any coding.',
		slug,
		version,
		isPremium,
		hasPro,
		nonce,
		action,
		licenseActiveNonce,
		pricingUrl,
		adminUrl,
		displayOurPlugins: true,
		media: {
			logo: `https://ps.w.org/${slug}/assets/icon-128x128.png`,
			banner: `https://ps.w.org/${slug}/assets/banner-772x250.png`,
			thumbnail: `https://bplugins.com/wp-content/uploads/2024/07/${slug}.png`,
			video: 'https://www.youtube.com/watch?v=G8w1cCDg-xQ',
			isYoutube: true
		},
		pages: {
			org: `https://wordpress.org/plugins/${slug}/`,
			landing: `https://bplugins.com/products/${slug}/`,
			docs: `https://bplugins.com/docs/${slug}/`,
			pricing: `https://bplugins.com/products/${slug}/pricing`,
		},
		freemius: {
			product_id: '20796',
			plan_id: '34657',
			public_key: 'pk_83e08cd3a331120bb1ecaa8211496',
		},
		proFeatures: [
			'Full markup, style, and behavior control.',
			'Toggle fullscreen, PiP, and settings.',
			'Custom player colors to match your brand.',
			'Build and embed playlists with Elementor.',
			'Support for HLS and DASH streaming.',
			'Add captions and subtitles to your videos.',
			'Picture-in-Picture (PiP) support.',
			'Classic Audio Playlist – Traditional playlist layout for audio files with familiar browser-style controls.',
			'Classic Video Playlist – Traditional playlist layout for video files with familiar browser-style controls.',
			'Regular updates with new features and improvements.'
		]
	}
}

export const demoInfo = {
	title: 'Live Overview',
	description: 'Click on any style to view it live',
	allInOneLabel: 'See All Demo',
	allInOneLink: 'https://bplugins.com/products/media-player-addons-for-elementor/',
	demos: [
		{
			icon: VimeoIcon,
			title: 'Vimeo Video Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/vimeo-video-player/'
		},
		{
			icon: html5AudioIcon,
			title: 'HTML5 Audio Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/html5-audio-player/'
		},
		{
			icon: advanceAudioPlaylistIcon,
			title: 'Advance Audio Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/advance-audio-playlist/'
		},
		{
			icon: html5videoIcon,
			title: 'HTML5 Video Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/html5-video-player/'
		},
		{
			icon: artPlayerIcon,
			title: 'Art Video Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/art-player-video-player/'
		},
		{
			icon: dPlayerIcon,
			title: 'dPlayer',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/dplayer-video-player/'
		},
		{
			icon: advanceVideoPlayerIcon,
			title: 'Advance Video Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/advance-video-player/'
		},
		{
			icon: youTubeIcon,
			title: 'Youtube Video Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/youtube-video-player/'
		},
		{
			icon: advanceAudioPlayerIcon,
			title: 'Advance Audio Player',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/advance-audio-player/'
		},
		{
			icon: videoPlaylistIcon,
			title: 'Advance Video Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/advance-video-player-playlist/'
		},
		{
			icon: audioPlaylistIcon,
			title: 'Audio Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/audio-player-playlist/'
		},
		{
			icon: classicAudioPlaylistIcon,
			title: 'Classic Audio Playlist -- Light',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/classic-audio-playlist-light/'
		},
		{
			icon: classicVideoPlaylistIcon,
			title: 'Classic Video Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/classic-video-player-playlist/'
		},
		{
			icon: cardAudioPlaylistIcon,
			title: 'Card Style Audio Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/card-audio-playlist/'
		},
		{
			icon: modernAudioPlaylistIcon,
			title: 'Modern Audio Player Playlist',
			description: '',
			category: '',
			type: 'iframe',
			url: 'https://elementor.bplugins.com/demo/modern-audio-playlist/'
		}
	]
}


export const pricingInfo = {
	logo: `https://ps.w.org/${slug}/assets/icon-128x128.png`, // Optional
	pluginId: 20796,
	planId: 34657,
	licenses: [
		1,
		3,
		null
	],
	button: {
		label: 'Buy Now ➜'
	},
	featured: {
		selected: 3, // choose from licenses item
	}
}

export const welcomeInfo = (adminUrl) => ({
	keywords: ['Audio Players', 'Video Players', 'Playlists', 'HTML5', 'YouTube & Vimeo', 'HLS/DASH Streaming'],
	keywordsLabel: 'Features',
	startButton: {
		label: 'Create New Page',
		url: `${adminUrl}/wp-admin/post-new.php?post_type=page`
	},
	gettingStarted: {
		tabs: [
			{
				key: 'elementor',
				label: 'Elementor',
				icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line></svg>,
				steps: [
					{
						num: 1,
						title: 'Add a New Page or Post',
						body: 'Open the WordPress admin dashboard, navigate to Pages or Posts, and click <strong>Add New Page</strong>. Then click <strong>Edit with Elementor</strong> to open the builder.',
						link: { url: `${adminUrl}/wp-admin/post-new.php?post_type=page`, label: 'Add New Page' }
					},
					{
						num: 2,
						title: 'Search for Media Player Widgets',
						body: 'In the Elementor widgets library panel on the left, search for <strong>Media Player</strong> or look under the <strong>Media Player Addons</strong> category to see all 15 widgets.'
					},
					{
						num: 3,
						title: 'Drag & Drop a Player Widget',
						body: 'Drag your preferred media widget (e.g. <strong>HTML5 Audio Player</strong>, <strong>Classic Audio Playlist</strong>, <strong>YouTube Video Player</strong>) and drop it onto your section layout.'
					},
					{
						num: 4,
						title: 'Configure Settings & Publish',
						body: 'Paste your media URLs (YouTube, Vimeo, MP3, MP4, etc.), choose styles (colors, layouts), and click <strong>Publish</strong> to make it live.'
					}
				]
			}
		]
	},
	changelogs: [
		{
			version: '1.1.8  - 11 July, 2026',
			type: 'update',
			list: [
				'<strong>Update:</strong> Freemius SDK to 2.13.4',
				'<strong>Update:</strong> Admin Dashboard: Improved UI with better feature organization.',			
			]
		},
		{
			version: '1.1.7  - 28 June, 2026',
			type: 'update',
			list: [
				'<strong>Update:</strong> Freemius SDK to 2.13.2',
				'<strong>Remove:</strong> Lock functionality from free version',	
			]
		},
		{
			version: '1.1.6  - 18 May, 2026',
			type: 'update',
			list: [
				'<strong>Release:</strong> New Version v1.1.6',
				'<strong>Update:</strong> Fix External Services Section',
				'<strong>Update:</strong> Remove all unused code',
				'<strong>Fix:</strong> Fix all naming conflict'
			]
		},
		{
			version: '1.1.5  - 15 Apr, 2026',
			type: 'new',
			list: [
				'<strong>Release:</strong> New Widget Modern Audio Player Playlist',
			]
		},
		{
			version: '1.1.4  - 31 Mar, 2026',
			type: 'new',
			list: [
				'<strong>Release:</strong> New Widget Card Style Audio Player Playlist',
				'<strong>Update:</strong> SDK Version 2.13.1'
			]
		},
		{
			version: '1.1.3  - 28 Feb, 2026',
			type: 'new',
			list: [
				'<strong>Release:</strong> New Admin Dashboard',
			]
		},
		{
			version: '1.1.2  - 07 Feb, 2026',
			type: 'new',
			list: [
				'<strong>Release:</strong> New Widget Video Player Playlist',
				'<strong>Add:</strong> Classic Video Player Playlist Widget',
			]
		},
		{
			version: '1.1.1  - 31 Jan, 2026',
			type: 'update',
			list: [
				'<strong>Update:</strong> New Feature for Vimeo Video Player',
				'<strong>Update:</strong> New Feature for YouTube Video Player',
			]
		},
		{
			version: '1.1.0  - 06 Jan, 2026',
			type: 'new',
			list: [
				'<strong>Release:</strong> New Feature for Classic Audio Playlist',
			]
		},
		{
			version: '1.0.11  - 05 Jan, 2026',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Dashboard JS Error',
			]
		},
		{
			version: '1.0.10  - 01 Jan, 2026',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Advance Player Missing Issue',
				'<strong>Fixed:</strong> Audio Player JS Error',
				'<strong>Add:</strong> New Feature of Advance Audio Player',
			]
		},
		{
			version: '1.0.9 – 15 Dec, 2025',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Video Player Style Error',
			]
		},
		{
			version: '1.0.8 – 29 Nov, 2025',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Audio Player JS Error',
			]
		},
		{
			version: '1.0.7 – 18 Sep, 2025',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Video Playlist PHP Error',
			]
		},
		{
			version: '1.0.6 – 16 Sep, 2025',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Vulnerability Issue',
			]
		},
		{
			version: '1.0.3 – 17 Sep, 2023',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Deprecated issue',
			]
		},
		{
			version: '1.0.2 – 1/27/2022',
			type: 'fix',
			list: [
				'<strong>Fixed:</strong> Deprecated issue',
				'<strong>Fixed:</strong> Advanced Player issue'
			]
		},
		{
			version: '1.0.1',
			type: 'new',
			list: [
				'<strong>Added:</strong> new blocks. (dPlayer)'
			]
		},
		{
			version: '1.0.0',
			type: 'new',
			list: [
				'<strong>First:</strong> release'
			]
		}
	],
	changelogsLimit: 6,
	changelogsReadMoreLabel: 'View More Changelogs',
})
